export default __webpack_public_path__ + "static/accordion_angle-6def9728ffcb3992b29aea691861af86.png";